const COOKIE_NAME = 'gu_chunk_reload'
const RELOAD_TTL_SEC = 60 * 60

const isChunkLoadError = (error) => {
  if (!error) {
    return false
  }

  const name = error.name ? String(error.name) : ''
  const message = error.message ? String(error.message) : ''

  return (
    name === 'ChunkLoadError' ||
    message.indexOf('Loading chunk') !== -1 ||
    message.indexOf('Loading CSS chunk') !== -1
  )
}

const isHashedReactAppAsset = (url) =>
  typeof url === 'string' && /\/frontend\/react-app\/.+\.[a-f0-9]{8}/i.test(url)

const hasReloadCookie = () => {
  const prefix = `${COOKIE_NAME}=`
  const parts = document.cookie.split('; ')
  for (let i = 0; i < parts.length; i += 1) {
    if (parts[i].indexOf(prefix) === 0) {
      return true
    }
  }
  return false
}

const markReloadAttempt = () => {
  try {
    if (hasReloadCookie()) {
      return false
    }
    const secure = window.location.protocol === 'https:' ? '; secure' : ''
    document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${RELOAD_TTL_SEC}; samesite=lax${secure}`
    return true
  } catch {
    return false
  }
}

const clearWorkerCaches = () => {
  if (!('caches' in window)) {
    return Promise.resolve()
  }

  return caches
    .keys()
    .then((keys) => Promise.all(keys.map((key) => caches.delete(key))))
}

const reloadAfterCacheDrop = () => {
  if (!markReloadAttempt()) {
    return
  }

  const reload = () => {
    window.location.reload()
  }

  clearWorkerCaches().then(reload).catch(reload)
}

/** Production: failed webpack chunk → drop Cache Storage once, then full reload. */
export const installChunkLoadReload = () => {
  window.addEventListener(
    'error',
    (event) => {
      const target = event.target
      if (
        target &&
        (target.tagName === 'SCRIPT' || target.tagName === 'LINK') &&
        isHashedReactAppAsset(target.src || target.href)
      ) {
        reloadAfterCacheDrop()
        return
      }
      if (isChunkLoadError(event.error)) {
        reloadAfterCacheDrop()
      }
    },
    true
  )

  window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason)) {
      reloadAfterCacheDrop()
    }
  })
}
